import { SummaryCard } from "@common";

function fmt(value) {
  if (value == null) return "—";
  const abs = Math.abs(Math.round(value));
  const str = `$${abs.toLocaleString("en-CA")}`;
  return value < 0 ? `-${str}` : str;
}

function fmtNet(value) {
  if (value == null) return "—";
  const abs = Math.abs(Math.round(value));
  const str = `$${abs.toLocaleString("en-CA")}`;
  return value >= 0 ? `+${str}` : `-${str}`;
}

const TODAY_LABEL = new Date().toLocaleDateString("en-CA", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

export default function CashFlowSummary({
  openingBalance = null,
  totalInflow = null,
  totalOutflow = null,
  netCashFlow = null,
  endingBalance = null,

  inflowChange = null,
  outflowChange = null,
  netChange = null,
  endingChange = null,
}) {
  return (
    <div className="flex flex-wrap gap-3 mb-6">
      <SummaryCard
        label="Opening Balance"
        value={fmt(openingBalance)}
        tag={openingBalance != null ? `Today — ${TODAY_LABEL}` : null}
      />
      <SummaryCard
        label="Total Inflow"
        value={fmt(totalInflow)}
        change={inflowChange}
        valueClass="text-smiles-green"
      />
      <SummaryCard
        label="Total Outflow"
        value={fmt(totalOutflow)}
        change={outflowChange}
        valueClass="text-smiles-redOrange"
      />
      <SummaryCard
        label="Net Cash Flow"
        value={fmtNet(netCashFlow)}
        change={netChange}
        valueClass={
          netCashFlow == null
            ? "text-palette-gray-primary"
            : netCashFlow >= 0
              ? "text-smiles-green"
              : "text-smiles-redOrange"
        }
      />
      <SummaryCard label="Ending Balance" value={fmt(endingBalance)} change={endingChange} />
    </div>
  );
}
